import { getInstance } from '@/auth'

const auth = getInstance()

export const navLinks = [
    {
        title: `account overview`,
        disabled: false,
        route: `account-dashboard`
    },
    {
        title: `your rmas`,
        disabled: false,
        route: `rma-history`
    },
    {
        title: 'your quotes',
        disabled: false,
        route: `saved-quotes`
    },
    {
        title: `your parts orders `,
        disabled: false,
        route: `parts-orders-history`
    },
    {
        title: 'support tickets',
        disabled: false,
        route: 'support-tickets'
    },
    ...(auth.userInOrganization()
        ? [
              {
                  title: `organizations`,
                  disabled: false,
                  route: `organizations`
              }
          ]
        : []),
    {
        title: `product registration `,
        disabled: false,
        route: `product-registration`
    },
    {
        title: `account settings `,
        disabled: false,
        route: `account-settings`
    },
    {
        title: `dashboard`,
        disabled: false,
        route: `dashboard`
    }
]
